export default function currency(value, promoType = '') {
    const isWeightTypePromo = promoType.includes('Weight')
    const perKg = isWeightTypePromo ? ' / kg' : ''

    const formattedValue = new Intl.NumberFormat('pl-PL', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
    }).format(value)

    return `${formattedValue} zł${perKg}`
}
